import ResizableForm from "../mixins/ResizableForm";
Vue.asyncComponent('cms-form', {
    mixins: [ResizableForm],
    computed: {
        bundle() {
            return this.$route.params.bundle;
        },
        definition() {
            return this.$route.params.definition;
        },
        objectId() {
            return this.$route.params.objectId;
        },
        relationString() {
            return this.$route.params.relationString;
        },
        query() {
            return this.$route.query;
        },
        forceDark() {
            // for now we force the list to dark mode if we are handeling media
            return this.bundle === 'media';
        }
    },
    methods: {
        /**
         * Go to grid
         *
         * @param data
         */
        goToGrid(data) {
            if (this.objectId !== 'new') {
                this.$emit('dataObjectChanged', this.objectId);
            } else {
                this.$emit('changed', data);
            }

            if(this.$route.name === 'blueprint-form') {
                this.$router.push({ name: 'blueprint'})
                this.$emit('save', data);
                return;
            }

            let gridRouteName = 'grid';
            if (this.$route.name === 'list-form') {
                gridRouteName = 'list';
                this.$emit('changed', data);
            }

            this.$router.push({ name: gridRouteName, params: {
                bundle: data.bundleId,
                gridDefinition: data.definitionId,
            }, query: this.$route.query
            });
        },
        /**
         * Close
         * When we closethe stacked window we go back to the previous route
         */
        close() {
            // go to the parent route
            this.$router.push({
                ...this.$route.matched[0],
                query: this.$route.query
            });
        }
    }
}, 'cms/pages/cms-form.html');